import { useContext } from 'react';

import { MFAttachedDocumentsContext } from '../providers/MFAttachedDocumentsProvider';

export const useMFAttachedDocumentsContext = () => {
  const context = useContext(MFAttachedDocumentsContext);

  if (!context) {
    throw new Error('useMFAttachedDocumentsContext must be used within an MFAttachedDocumentsProvider');
  }

  return context;
};
